import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { from, of } from 'rxjs';
import { catchError, map, mergeMap } from 'rxjs/operators';
import { fromApiEffectSwitchMap } from '@lib/store';
import {
  cancelGetReceiptRequest,
  failGetReceipt,
  setGetReceipt,
  setGetReceiptFromApi,
  updateGetReceipt,
  updateGetReceiptFromApi,
} from './get-receipt.actions';

/**
 * Service to handle async GetReceipt actions
 */
@Injectable()
export class GetReceiptEffect {
  /**
   * Set the state with the reply content, dispatch failGetReceipt if it catches a failure
   */
  public setFromApi$ = createEffect(() =>
    this.actions$.pipe(
      ofType(setGetReceiptFromApi),
      fromApiEffectSwitchMap(
        (reply, action) => setGetReceipt({ model: reply, requestId: action.requestId }),
        (error, action) => of(failGetReceipt({ error, requestId: action.requestId })),
        cancelGetReceiptRequest
      )
    )
  );

  /**
   * Update the state with the reply content, dispatch failGetReceipt if it catches a failure
   */
  public updateFromApi$ = createEffect(() =>
    this.actions$.pipe(
      ofType(updateGetReceiptFromApi),
      mergeMap((payload) =>
        from(payload.call).pipe(
          map((reply) => updateGetReceipt({ model: reply, requestId: payload.requestId })),
          catchError((err) => of(failGetReceipt({ error: err, requestId: payload.requestId })))
        )
      )
    )
  );

  constructor(protected actions$: Actions) {}
}
